/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import { fetchInvoice } from '../../lib/rest/invoiceAPIClient'
import InvoiceForm from './InvoiceForm'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import { parseNumber } from '@jalik/form-parser'
import useParsedQueryParam from '../../../../client/js/hooks/useParsedQueryParam'
import { Card, Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'
import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import { getInvoiceListLink } from '../../lib/links/invoiceLinks'

function InvoiceFormPage () {
  const intl = useIntl()
  const [searchParams] = useQueryParams()
  const params = useParams<{ id?: string }>()
  const invoiceId = parseInt(params.id, 10)

  const customerId = useParsedQueryParam('customerId', parseNumber)
  const estateId = useParsedQueryParam('estateId', parseNumber)
  const leaseId = useParsedQueryParam('leaseId', parseNumber)

  const invoiceQuery = useQuery({
    enabled: true,
    queryKey: ['invoice', invoiceId, searchParams],
    queryFn: () => invoiceId > 0
      ? fetchInvoice(invoiceId)
      : Promise.resolve({
        customerId,
        estateId,
        leaseId,
        type: searchParams.type
      } as Partial<Invoice>),
    refetchOnWindowFocus: false
  })
  const { data } = invoiceQuery

  const title = invoiceId > 0 && data != null
    ? data.reference
    : intl.formatMessage({
      id: 'create_invoice',
      defaultMessage: 'Créer une facture'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
            <AnchorLink to={getInvoiceListLink()}>
              <FormattedMessage
                id="invoices"
                defaultMessage="Factures"
              />
            </AnchorLink>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <Card shadow="sm">
          <LoadingHelper
            query={invoiceQuery}
            render={() => (
              <InvoiceForm initialValues={data} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default InvoiceFormPage
